import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  WORD_API_URL,
  WORD_APP_PATH,
  DOZEN_API_URL,
  DOZEN_APP_PATH
} from '../config';
import AppShell from './AppShell';
import { pointsLabel } from '../utils/dozen';
import './GameHub.css';

function wordStatus(data) {
  if (!data) return '';
  return data.solved ? 'Угадано ✓' : 'Ещё не угадано';
}

function dozenStatus(data) {
  if (!data) return '';
  if (data.phase === 'intro') return 'Ещё не сыграно';
  if (data.phase === 'finished') {
    return `${data.solvedCount} из ${data.wordLengths.length} · ${pointsLabel(data.score)}`;
  }
  return 'Игра идёт — таймер тикает!';
}

function moscowTime(iso) {
  if (!iso) return null;
  return new Intl.DateTimeFormat('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Moscow'
  }).format(new Date(iso));
}

const RULES_LINKS = [
  { to: `${WORD_APP_PATH}/rules`, label: 'Слово Дня' },
  { to: `${DOZEN_APP_PATH}/rules`, label: 'Дюжина' }
];

function RulesIcon() {
  return (
    <svg
      className="hub-rules__icon"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M4 5.5c2.6-1 5.3-.9 8 .6 2.7-1.5 5.4-1.6 8-.6v13c-2.6-1-5.3-.9-8 .6-2.7-1.5-5.4-1.6-8-.6z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path d="M12 6.1v13" fill="none" stroke="currentColor" strokeWidth="1.7" />
    </svg>
  );
}

export function HubCard({ title, subtitle, timing, status, badge, onClick, accent = false }) {
  return (
    <button
      type="button"
      className={`hub-card panel${accent ? ' hub-card--accent' : ''}`}
      onClick={onClick}
    >
      <span className="hub-card__top">
        <span className="hub-card__heading">
          <span className="hub-card__title">{title}</span>
          {badge ? <span className="hub-card__badge">{badge}</span> : null}
        </span>
        <span className="hub-card__chevron" aria-hidden="true">
          ›
        </span>
      </span>
      <span className="hub-card__subtitle">{subtitle}</span>
      {timing ? <span className="hub-card__timing">{timing}</span> : null}
      {status ? <span className="hub-card__status">{status}</span> : null}
    </button>
  );
}

function GameHub() {
  const navigate = useNavigate();
  const [word, setWord] = useState(null);
  const [dozen, setDozen] = useState(null);

  useEffect(() => {
    axios.get(`${WORD_API_URL}/game/today`).then((r) => setWord(r.data)).catch(() => {});
    axios.get(`${DOZEN_API_URL}/game/state`).then((r) => setDozen(r.data)).catch(() => {});
  }, []);

  const wordTime = moscowTime(word?.nextWordTime);
  const dozenTime = moscowTime(dozen?.nextPuzzleTime);

  return (
    <AppShell app={null} hideTabs>
      <div className="hub-content">
        <HubCard
          title="Слово Дня"
          subtitle="Одно слово из 9 букв."
          timing={`Время идёт с момента публикации${wordTime ? ` · новое слово в ${wordTime} МСК` : ''}`}
          status={wordStatus(word)}
          onClick={() => navigate(`${WORD_APP_PATH}/game`)}
        />
        <HubCard
          title="Дюжина"
          badge="New"
          subtitle="12 слов от 4 до 8 букв, по 30 секунд на каждое."
          timing={`Играйте когда удобно: таймер стартует, когда вы нажмёте «Начать»${
            dozenTime ? ` · новая дюжина в ${dozenTime} МСК` : ''
          }`}
          status={dozenStatus(dozen)}
          onClick={() => navigate(`${DOZEN_APP_PATH}/game`)}
        />

        <section className="hub-rules" aria-labelledby="hub-rules-title">
          <h2 id="hub-rules-title" className="hub-rules__title">
            Правила
          </h2>
          <div className="hub-rules__links">
            {RULES_LINKS.map((rule) => (
              <Link key={rule.to} to={rule.to} className="hub-rules__link">
                <RulesIcon />
                <span>{rule.label}</span>
              </Link>
            ))}
          </div>
        </section>
      </div>
    </AppShell>
  );
}

export default GameHub;
